import Link from 'next/link';
import { routeStore } from '~/stores/RouteStore';

interface BackLinkProps {
    classnames?: string;
    maxWidth?: string;
    previousRoute: string;
}

export function BackLink({ classnames, maxWidth, previousRoute }: BackLinkProps): JSX.Element {
    const showBackLink = routeStore.prevRoute && routeStore.prevRoute === previousRoute;
    return (
        <>
            {showBackLink && (
                <Link
                    href={previousRoute}
                    className={`${maxWidth && maxWidth != '' ? maxWidth : 'max-w-[1136px]'} mx-auto flex text-brown-600 items-center ${classnames}`}
                >
                    <svg
                        width={'15px'}
                        height={'10px'}
                        className={'transform rotate-180 mr-[5px]'}
                        viewBox={'0 0 18 12'}
                        fill={'none'}
                        xmlns={'http://www.w3.org/2000/svg'}
                    >
                        <path
                            d={
                                'M11.6663 1.33329L16.333 5.99996M16.333 5.99996L11.6663 10.6666M16.333 5.99996L1.33301 5.99996'
                            }
                            stroke={'#A86D37'}
                            stroke-width={'2'}
                            stroke-linecap={'round'}
                            stroke-linejoin={'round'}
                        />
                    </svg>{' '}
                    Back
                </Link>
            )}
        </>
    );
}
